module.exports = __webpack_public_path__ + "static/img/AIRWALLEX.03c39b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/AIRWALLEX.png
// module id = eUf3
// module chunks = 34